import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (default_image, t, onOpen) => [
    {
        label: t('discover.author.top_pages.page'),
        key: 'page',
        data: 'page',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.title;

            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) => (event.target.src = default_image)}
                                src={item.image ?? default_image}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong>
                                <a
                                    href={
                                        `/domains/${window.info.id}/pages/page?page=` +
                                        encodeURIComponent(item.page)
                                    }
                                >
                                    {item.title}
                                </a>
                                <a
                                    target="_blank"
                                    className="link-website d-inline-flex align-items-center justify-content-center"
                                    href={item.page}
                                    rel="noreferrer"
                                >
                                    <i className="icon-external-link"></i>
                                </a>
                            </strong>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('discover.author.top_pages.uniques'),
        key: 'uniques',
        data: 'uniques',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <span
                    title={item.uniqueHeadlines?.join(' , ')}
                    className="cursor-pointer"
                    onClick={() => onOpen(item)}
                >
                    {data}
                </span>
            );
        },
    },
    {
        label: t('discover.author.top_pages.lifespan'),
        key: 'lifespan',
        data: 'lifespan',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0,00')} Days</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.author.top_pages.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.author.top_pages.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.author.top_pages.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div className="col align-center">
                    <strong>{numeral(data).format('0.00%')}</strong>{' '}
                </div>
            );
        },
    },
];

export const FIELD_FOR_DOWNLOADS = (t) => [
    {
        label: t('discover.author.top_pages.uniqueHeadlines'),
        key: 'uniqueHeadlines',
        data: 'uniqueHeadlines',
        Component: Cell,
        renderCell: ({ data }) => {
            return Array.isArray(data) ? data.join(' , ') : data;
        },
    },
    {
        label: t('discover.author.top_pages.url'),
        key: 'page',
        data: 'page',
        Component: Cell,
    },
];
